import axios from "axios";

import { BASE_URL } from "../../src/utils/api_base_url_configration";



export const getProductTypeServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "product-type/list", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const addProductTypeServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "product-type/create", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const updateProductTypeServ = async (formData) => {
  try {
    const response = await axios.put(BASE_URL + "product-type/update", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
export const deleteProductTypeServ = async (id) => {
  try {
    const response = await axios.delete(BASE_URL + "product-type/delete/"+id);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
